const permissions = {
  whatsappScreen: [] as string[]
};

export default permissions;
